import { Component } from '@angular/core';
import { AccordionContentComponent } from '../accordion_content.component';

@Component({
  selector: 'yi-bigcommerce-builtin-reviews',
  template: require('./bigcommerce_builtin_reviews.component.html'),
  styles: [require('./bigcommerce_builtin_reviews.component.scss')]

})

export class BigcommerceBuiltinReviewsComponent extends AccordionContentComponent {

}
